export default "__VITE_ASSET__Dg4YAEGc__"